export const normalizeSecureMessageContent = (content: string): string => {
  const trimmed = content?.trim() ?? '';

  if (!trimmed) {
    return '';
  }

  if (
    trimmed.includes('&lt;') ||
    trimmed.includes('&gt;') ||
    trimmed.includes('&amp;')
  ) {
    return trimmed
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'")
      .replace(/&amp;/gi, '&');
  }

  return trimmed;
};

export const containsSecureMessageHtml = (content: string): boolean =>
  /<[a-z][\s\S]*>/i.test(content.trim()) ||
  /&lt;[a-z][\s\S]*&gt;/i.test(content.trim());

/** Plain text for single-line list labels (subject, previews). */
export const stripSecureMessageHtml = (content: string): string => {
  const normalized = normalizeSecureMessageContent(content);

  if (!normalized) {
    return '';
  }

  return normalized
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};
